import React from "react";

/* ============= NEW HEADER FACEBOOK VERIFIED BADGE =============
   Stacked design — "Verified" on top + facebook logo + "facebook" below.
   Soft light-blue pill background. */
export const FbVerifiedBadge = () => (
  <div
    data-testid="fb-verified-badge"
    className="rounded-2xl px-2.5 py-1.5 text-center leading-tight border"
    style={{
      background: "#E7F3FF",
      borderColor: "#CFE4FF",
      minWidth: "72px",
    }}
  >
    <div className="flex items-center justify-center text-[12px] font-extrabold" style={{ color: "#1877F2" }}>
      <span>Verified By</span>
    </div>
    <div className="flex items-center justify-center gap-1 text-[11px] font-bold mt-0.5" style={{ color: "#1877F2" }}>
      <svg width="11" height="11" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C6.477 2 2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.879V14.89H7.898V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33V21.88C18.343 21.128 22 16.99 22 12c0-5.523-4.477-10-10-10z"/></svg>
      <span>facebook</span>
    </div>
  </div>
);

/* ============= Google Review pill — multi-color G + rating + count =============
   White pill with subtle shadow. */
export const GoogleReviewPill = () => (
  <div
    data-testid="google-review-pill"
    className="inline-flex items-center gap-1.5 bg-white rounded-full px-3 py-1.5 shadow-sm border border-slate-100"
  >
    <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
      <path fill="#FFC107" d="M43.611 20.083H42V20H24v8h11.303c-1.649 4.657-6.08 8-11.303 8c-6.627 0-12-5.373-12-12s5.373-12 12-12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4C12.955 4 4 12.955 4 24s8.955 20 20 20s20-8.955 20-20c0-1.341-.138-2.65-.389-3.917z" />
      <path fill="#FF3D00" d="M6.306 14.691l6.571 4.819C14.655 15.108 18.961 12 24 12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4C16.318 4 9.656 8.337 6.306 14.691z" />
      <path fill="#4CAF50" d="M24 44c5.166 0 9.86-1.977 13.409-5.192l-6.19-5.238C29.211 35.091 26.715 36 24 36c-5.202 0-9.619-3.317-11.283-7.946l-6.522 5.025C9.505 39.556 16.227 44 24 44z" />
      <path fill="#1976D2" d="M43.611 20.083H42V20H24v8h11.303c-.792 2.237-2.231 4.166-4.087 5.571l6.19 5.238C36.971 39.205 44 34 44 24c0-1.341-.138-2.65-.389-3.917z" />
    </svg>
    <span className="font-extrabold text-slate-900 text-[13px]">4.8</span>
    <span className="inline-flex gap-0.5 text-amber-500">
      {[0,1,2,3,4].map((i) => (
        <svg key={i} width="11" height="11" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.5l2.95 6.6 7.05.71-5.3 4.81 1.62 7.04L12 17.91l-6.32 3.75 1.62-7.04L2 9.81l7.05-.71z"/></svg>
      ))}
    </span>
    <span className="font-bold text-slate-500 text-[11.5px]">5.9K+</span>
  </div>
);

/* ============= Our store review pill — shield + buyers count =============
   Light green pill. */
export const StoreReviewPill = () => (
  <div
    data-testid="store-review-pill"
    className="inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 border"
    style={{ background: "#E8F8EE", borderColor: "#B8E6C7" }}
  >
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#0a7a44" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
      <path d="M9 12l2 2 4-4" />
    </svg>
    <span className="font-extrabold text-emerald-900 text-[12.5px]">3.4K+ trusted buyers</span>
  </div>
);
